/**
 * Chat API Hooks
 *
 * React Query hooks for chat assistant API operations.
 */

import { useMutation } from '@tanstack/react-query';
import { chatApi, type SendMessageRequest } from '../api/chatApi';

/**
 * Send a message to the chat assistant. Resolves the reply payload itself
 * (not the axios response).
 */
export function useSendMessage() {
  return useMutation({
    mutationFn: (request: SendMessageRequest) => chatApi.send(request),
  });
}
